export const getDocument = (): Document => window.document;

export const getDocumentStyles = (): CSSStyleDeclaration => getDocument().documentElement.style;

export const getLocation = (): Location => window.location;
